import { ApiComponent } from '@ibe/api';

class PackageCustomizerColumn {
  component: ApiComponent;

  relatedComponent?: ApiComponent;

  colSpan: number;

  id: string;
}

export default PackageCustomizerColumn;
